import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {}

  showHelp(ev) {
    ev.preventDefault();

    gtag("event", "show_help");

    window.Beacon("open");
  }
}
